/**
 * Normative constants — ARCHITECTURE.md Appendix B. Every number the kernel uses lives here so the
 * tests, the simulation and the UI agree on one source.
 */
export const HB_INTERVAL_MS = 1_000;
export const BURST_COUNT = 4;
export const BURST_SPACING_MS = 250;
export const PRE_FLUSH_MIN_PINGS = 3;
export const PONG_LOST_MS = 2_000;
export const RED_AFTER_MS = 4_000;
export const SERVER_LOST_MS = 5_000;
export const SERVER_WS_TERMINATE_MS = 20_000;
export const WIN_CONN_MS = 30_000;
export const WIN_SYNC_MS = 60_000;
export const SAMPLE_MAX_AGE_MS = 120_000;
export const MIN_SAMPLES_VALID = 3;
export const DRIFT_PPM = 200;
export const EPS_MS = 2;
export const SLEEP_DIVERGENCE_MS = 500;
export const U_SELF_MAX_ENTER = 500;
export const U_SELF_MAX_EXIT = 450;
export const U_SELF_CAP_ENTER = 750;
export const U_SELF_CAP_EXIT = 700;
export const PAIR_MAX_ENTER = 1_000;
export const PAIR_MAX_EXIT = 900;
export const DWELL_CONN_MS = 10_000;
export const DWELL_SYNC_MS = 3_000;
export const LOSS_ENTER = 3;
export const LOSS_EXIT = 1;
export const JITTER_ENTER_MS = 600;
export const JITTER_EXIT_MS = 400;
export const RECONNECTS_ENTER = 2;
export const STEP_SILENT_MS = 30;
export const AUDIO_REANCHOR_MS = 10_000;
export const AUDIO_REANCHOR_THRESHOLD_MS = 15;
export const CUE_RESCHEDULE_STEP_MS = 200;
export const SUSPEND_DIVERGENCE_MS = 500;
export const T0_GATE_MIN_MS = 250;
export const T0_GATE_FACTOR = 3;
export const EARLY_CLAMP_MS = 250;
export const MAX_FIRE_AGE_MS = 600_000;
export const REVIEW_MARGIN_MS = 5_000;
export const LATE_FLAG_MS = 2_000;
export const F_MIN_S = 8.0;
export const F_MAX_S = 300.0;
export const WARN_WINDOW_MS = 5_000;
export const MARK_TONE_MS = 3_000;
export const AAR_DELAY_MS = 10_000;
export const LASER_OFF_TIMEOUT_MS = 30_000;
export const READY_STALE_MS = 30_000;
export const AUTO_SAVE_MIN = 60;
export const CUE_LEADER_STALE_MS = 2_000;
export const SHOT_LATE_AFTER_MS = 5_000;
export const LASING_CALLOUT_AFTER_MS = 3_000;
export const LASER_MARK_LATE_TAIL_MS = 3_000;
export const VOICE_LATE_MS = 2_000;
export const SERVER_CLOCK_DISCONTINUITY_MS = 250;
export const SERVER_ANCHOR_PERSIST_MS = 10_000;
export const WELCOME_REANCHOR_MS = 2_000;
export const OUTBOX_MAX_AGE_MS = 3 * 24 * 3_600_000;
export const DEDUPE_RETENTION_MS = 7 * 24 * 3_600_000;
export const RETRY_DELAYS_MS = [0, 500, 1_000, 2_000, 4_000] as const;
export const RETRY_CAP_MS = 5_000;
export const RETRY_JITTER = 0.2;
export const ATTEMPT_TIMEOUT_MS = 6_000;
export const ATTEMPT_TIMEOUT_FIRE_MS = 3_000;
/** Beep-ramp onsets relative to the mark (ms). ARCHITECTURE §11.4. */
export const RAMP_ONSETS_MS = [-5000, -4100, -3300, -2600, -2000, -1500, -1100, -800, -550, -350, -200] as const;
export const RAMP_BEEP_MS = 120;
export const LASER_TONE_HZ = 880;
export const IMPACT_TONE_HZ = 1175;
export const FIRE_ALARM_HZ = 660;
